import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AttachmentVisibilitySelectorComponent } from './attachment-visibility-selector/attachment-visibility-selector.component';
import { CreateDocumentTemplateModalComponent } from './create-document-template-modal/create-document-template-modal.component';
import { DocumentFormatModalComponent } from './document-format-modal/document-format-modal.component';
import { DocumentTemplateDetailPageComponent } from './document-template-detail-page/document-template-detail-page.component';
import { DocumentTemplatePreviewModalComponent } from './document-template-preview-modal/document-template-preview-modal.component';
import { DocumentTemplatesTableComponent } from './document-templates-table/document-templates-table.component';
import { MergeDocumentPreviewComponent } from './merge-document-preview/merge-document-preview.component';

@NgModule({
  imports: [
    GCCoreModule
  ],
  declarations: [
    DocumentTemplatesTableComponent,
    DocumentTemplateDetailPageComponent,
    CreateDocumentTemplateModalComponent,
    MergeDocumentPreviewComponent,
    DocumentFormatModalComponent,
    AttachmentVisibilitySelectorComponent,
    DocumentTemplatePreviewModalComponent
  ],
  exports: [
    MergeDocumentPreviewComponent,
    AttachmentVisibilitySelectorComponent
  ]
})
export class DocumentTemplateModule { }
